<template>
  <div class="article-box">
    <h5 class="article_title">交易规则</h5>
    <hr>

    <div class="article_content" v-html="data">

      <!--<p><span class="rules_content"><img src="../assets/img/9b217b50c097219b81abde61aa8a79c2.png" title="441734721.png" alt="441734721.png">&nbsp;<strong>免费体验股票产品特点</strong></span></p>
      <p><span class="rules_content">产品简介：“免费体验”是易博配资为用户提供的“零风险”股票体验产品，旨在对刚接触股票的用户提供一个体验的机会，也希望新用户通过此&nbsp; &nbsp; 产品了解并熟悉易博配资的操作流程。</span></p>
      <p><span class="rules_content">①股票额度：支付100元保证金，易博配资赠送8788元，合计8888元操盘资金</span></p>
      <p><span class="rules_content">②股票费用：管理费全免。</span></p>
      <p><span class="rules_content">③使用期限：2个交易日。</span></p>
      <p><span class="rules_content">④盈亏分配：当您投资盈利时，盈利全归您，退还100元保证金。如投资亏损，易博配资将亏损的部分补偿给您，退还100元保证金。简单说就是盈利归您，亏损归易博配资。</span></p>
      <p><span class="rules_content">⑤特殊要求：每个用户仅可申请一笔免费体验合约。</span></p>
      <p><span class="rules_content"><img src="../assets/img/f229243b10a101a0fed3494e6113c8d4.png" title="245208180715.png" alt="245208180715.png">&nbsp;<strong>操盘前必读</strong></span></p>
      <p><span class="rules_content">①请尽量保持总操盘资金高于亏损警戒线，及时添加风险保证金，以免到达亏损平仓线被强制平仓；</span></p>
      <p><span class="rules_content">②总操盘资金到达亏损平仓线后，如不想添加风险保证金，请及时卖出股票，以免出现超额亏损；</span></p>
      <p><span class="rules_content">③请尽量保持账户余额充足，以免无法支付合约管理费，被自动平仓</span></p>
      <p><span class="rules_content"><img src="../assets/img/68c26087f3c4b1db7d8b99ec66aeae20.png" title="8888808181645.png" alt="8888808181645.png">&nbsp;<strong>合约申请流程</strong></span></p>
      <p><span class="rules_content">&nbsp; 账户注册-&#45;&#45;选择配资股票-&#45;&#45;支付合约费用-&#45;&#45;股票交易-&#45;&#45;结算账户交割</span></p>
      <p><img src="../assets/img/aae1394c092e1cc52b87ffa82a9472f3.png" title="54325324534258182112.png" alt="54325324534258182112.png">&nbsp;<strong>交易限制 -股票交易限制</strong><br></p>
      <p><span class="rules_content">①不得购买权证类可以T+0交易的证券；</span></p>
      <p><span class="rules_content">②不得购买首日上市新股（或复牌首日股票）等当日不设涨跌停板限制的股票；</span></p>
      <p><span class="rules_content">③不得购买平台当日限制股票。</span></p>
      <p><span class="rules_content"><img src="../assets/img/9e143ae6bc6056828426ec4c3b01b507.png" title="23534281919.png" alt="23534281919.png">&nbsp;<strong>什么是警戒线？</strong></span></p>
      <p><span class="rules_content">亏损掉杠杆保证金的50%为警戒线时，系统会在通知消息给您提示消息，当实盘资产低于警戒线时，您将被限制买入新的股票，但允许卖出已持有的股票，您可以通过增加保证金的方式解除限制买入。</span></p>
      <p><span class="rules_content"><img src="../assets/img/faff5f7c2337279aaabaf61b8b3ddf74.png" title="天热问题2251.png" alt="天热问题2251.png">&nbsp;<strong>什么是止损线？</strong></span></p>
      <p><span class="rules_content">亏损掉杠杆保证金的80%为平仓线。当总操盘资金低于止损线以下时，我们将有权把您的股票进行平仓，为避免平仓发生，请时刻关注本金是否充足。</span></p>
      <p><br></p>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "helprules",
      data(){
        return{
          data:''
        }
      },
      methods:{
        getData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                'nozzle': 'protocol',
                'type': 14,
              }
            })  .then(res => {
            let resData = res.data;
            if (res.data.code == 1) {
              that.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
        }
      },
      mounted() {
        this.getData();
      }
    }
</script>

<style scoped>
  .article_title{
    font-size: 20px;
    font-weight: 500;
  }
  .article_content>>img{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/helprules.vue